import { mapCourse, stripHtmlText } from './dashboardMappers';

const PLACEHOLDER_AVATAR =
  'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop&crop=face';

function mapCertification(cert, index) {
  if (typeof cert === 'string') {
    return { id: index + 1, label: cert.trim() };
  }

  return {
    id: cert.id ?? index + 1,
    label: (cert.label || cert.name || cert.title || '').trim(),
  };
}

function mapAchievement(item) {
  if (typeof item === 'string') return item.trim();
  return (item?.title || item?.description || item?.label || '').trim();
}

export function mapInstructorDetail(data) {
  if (!data) return null;

  const qualification = data.qualification?.trim();
  const experienceYears = data.experience_years ?? data.experience;
  const videoCount = data.number_of_videos ?? data.videos_count;

  const stats = [
    qualification ? { id: 'degree', label: qualification } : null,
    experienceYears != null && experienceYears !== ''
      ? { id: 'experience', label: `${experienceYears} yrs Experience` }
      : null,
    videoCount != null && videoCount !== ''
      ? { id: 'videos', label: `${videoCount} Videos` }
      : null,
  ].filter(Boolean);

  const certifications = (data.certifications || [])
    .map(mapCertification)
    .filter((cert) => cert.label);

  const achievements = (data.achievements || []).map(mapAchievement).filter(Boolean);

  const courses = (data.courses || []).map(mapCourse).filter(Boolean);

  const about = stripHtmlText(data.about || data.bio || '');
  const coverPhoto = data.cover_photo_url?.trim() || null;

  const certificationStory =
    coverPhoto || about
      ? {
          image: coverPhoto,
          imageCaption: (data.title || data.name || '').trim(),
          text: about,
        }
      : null;

  return {
    id: data.id,
    name: data.name || 'Instructor',
    title: (data.title || '').trim() || 'Expert',
    bio: about,
    profileImage: data.profile_image_url?.trim() || PLACEHOLDER_AVATAR,
    stats,
    certifications,
    certificationStory,
    achievements,
    courses,
  };
}
